'use strict';

/**
 * Tiny global intent recorder.
 *
 * Captures clicks on `[data-rp-intent-trigger="<name>"]` during the page-load
 * window so consumers (e.g. lazily-initialised facades) can detect that a user
 * already clicked their CTA before their handler was installed. Each entry is
 * an object `{ type: string|null }` carrying the optional companion
 * `data-rp-intent-type` so consumers can branch on intent variants without
 * losing the truthy-check ergonomics.
 *
 * State lives on `globalThis` so that separate webpack bundles share the same
 * map — whichever bundle loads first installs the listener and creates the
 * map; later requires reuse it.
 *
 * @typedef {{ type: string|null }} LoadingIntent
 */

globalThis.__rp_loading_intent = globalThis.__rp_loading_intent || {};

if (!globalThis.__rp_loading_intent_installed) {
	globalThis.__rp_loading_intent_installed = true;

	document.addEventListener('click', (event) => {
		const triggerEl = event.target.closest('[data-rp-intent-trigger]');
		if (triggerEl) {
			const intentTrigger = triggerEl.dataset.rpIntentTrigger;
			globalThis.__rp_loading_intent[intentTrigger] = {
				type: triggerEl.dataset.rpIntentType || null,
			};
		}
	});
}

module.exports = { loadingIntent: globalThis.__rp_loading_intent };
